<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Question' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Competency' | translate}}</label>
      <select class="form-control" [(ngModel)]="entity.competencyId">
        <option *ngFor="let competency of competencies" [value]="competency.id">
          {{competency.name | translate}} ({{competency.type}})
        </option>
      </select>
    </div>

    <div class="form-group">
      <label>{{'Question' | translate}}</label>
      <input type="text" class="form-control" [(ngModel)]="entity.question" />
    </div>

    <div class="form-group">
      <label>{{'Answer' | translate}} 1</label>
      <textarea class="form-control" [(ngModel)]="entity.answer1" rows="2"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Answer' | translate}} 2</label>
      <textarea class="form-control" [(ngModel)]="entity.answer2" rows="2"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Answer' | translate}} 3</label>
      <textarea class="form-control" [(ngModel)]="entity.answer3" rows="2"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Answer' | translate}} 4</label>
      <textarea class="form-control" [(ngModel)]="entity.answer4" rows="2"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Answer' | translate}} 5</label>
      <textarea class="form-control" [(ngModel)]="entity.answer5" rows="2"></textarea>
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
